import { Alert, Button, Grid, IconButton, InputAdornment, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import React, { useState } from 'react';
import { IAuthResponse, User, UserRoles, initialUser } from '../../Interfaces';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { addOrUpdateUser } from '../../Data/ApiUserRequests';
import { useSelector } from 'react-redux';

interface ChildProps {
  setIsNewUserAdded: (value: number) => void;
}

const AddUserForm = (params: ChildProps) => {

    const bearerToken: IAuthResponse = useSelector((state: IAuthResponse) => state)
    const [currentUser, setCurrentUser] = useState<User>(initialUser);
    const [errorAddText, setErrorAddText] = useState('');
    const [operationAddResult, setOperationAddResult] = useState('')
    const [userAdded, setUserAdded] = useState(0)
    const [showPassword, setShowPassword] = useState(false);
    const [isAddUpdateOpenDialog, setIsAddUpdateOpenDialog] = useState(false)


    const addUser = () => {
        if (!currentUser.fullName) { setErrorAddText('Leer Name'); return;}
        if (!currentUser.email) {setErrorAddText('Leer Email'); return;}
        addOrUpdateUser(currentUser, bearerToken.token)
          .then(response => {
            setIsAddUpdateOpenDialog(true)
            setOperationAddResult(response)
            setErrorAddText('')
            const newUserAdded = userAdded + 1
            params.setIsNewUserAdded(newUserAdded)
            setUserAdded(newUserAdded)
          }).catch((error) => {
            setErrorAddText(error)
          })
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      setCurrentUser({ ...currentUser, [name]: value });
    };
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        const { name, value } = event.target;
        setCurrentUser({ ...currentUser, [name]: value });
      };


    return (
        <div>

                  <h2>Neuen Nutzer hinzufügen</h2>
                  <label className='errorText'>{errorAddText}</label>
        {!isAddUpdateOpenDialog &&

          <Grid container spacing={2} p={1}>
            <Grid item xs={0} md={3}></Grid>
            <Grid item xs={12} md={7}>
              <TextField
                required
                type="text"
                label='Name'
                placeholder="Name"
                name="fullName"
                value={currentUser.fullName}
                onChange={handleInputChange}
                size='small' sx={{ width: '240px' }}
              /></Grid>
              <Grid item xs={0} md={3}></Grid>
              <Grid item xs={12} md={7}>
              <TextField
                type="email"
                label='Email' required
                placeholder="Email"
                name="email"
                value={currentUser.email}
                onChange={handleInputChange}
                size='small' sx={{ width: '240px' }}
              /></Grid>
              <Grid item xs={0} md={3}></Grid>
              <Grid item xs={12} md={7}>
              <TextField
                type="text"
                label='Nutzername' required
                placeholder="Nutzername"
                name="userName"
                value={currentUser.userName}
                onChange={handleInputChange} size='small' sx={{ width: '240px' }}
              /></Grid>
              <Grid item xs={0} md={3}></Grid>
              <Grid item xs={12} md={7}>
              <TextField
                type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                name='password' required
                label='Passwort'
                onChange={handleInputChange}
                value={currentUser.password}
                size='small'
                InputProps={{ // <-- This is where the toggle button is added.
                  style: {
                    width: '240px', boxSizing: 'border-box'
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)} size='small'
                        onMouseDown={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              /></Grid>
              <Grid item xs={0} md={3}></Grid>
              <Grid item xs={12} md={7}>
              <Select
                type="text"
                label='Rolle'
                placeholder="Group"
                name="role"
                size='small' sx={{ width: '240px' }}
                value={(currentUser.role === undefined) ? '' : currentUser?.role?.toString()} onChange={handleSelectChange}>
                {
                  UserRoles.map(u => {
                    return (
                      <MenuItem key={`user`} value={u.roleValue} selected={(currentUser.roleString === u.roleTitle) ? true : false}>{u.roleTitle}</MenuItem>
                    )
                  })
                }
              </Select>
            </Grid>
            <Grid item xs={0} md={3}></Grid>
            <Grid item xs={12} md={6}>
              <Button variant='contained' onClick={addUser}>neuen Nutzer hinzufügen</Button>
            </Grid>
            <Grid xs={0} md={3}></Grid>
          </Grid>
        }

      {isAddUpdateOpenDialog &&
      <Alert severity={errorAddText !== '' ? 'error' : 'success' } >
          {errorAddText !== '' ?  errorAddText : operationAddResult  }
        </Alert>

      }

        </div>
    );
};

export default AddUserForm;